import React from 'react';
import RouteTable from 'shared/decision/RouteTable';
import TargetPicker, { NEW_PASS, NEW_FAIL, NEW_STEP } from './TargetPicker';
import { edgesToTable, tableToEdges } from './routeEdges';

/**
 * Where a Decision model step goes next: the same route table the agents'
 * Decide node uses, with the next step of the eval as each route's target.
 * Route i is edge i; Otherwise is the default edge, always last.
 */
export default function DecisionRoutes({ graph, nodeId, onChange, onNewVerdict, onNewStep, readOnly = false }) {
  const node = graph.nodes[nodeId];
  const questions = (node && node.config && node.config.questions) || {};
  const table = edgesToTable(node.edges || [], questions);

  const commit = (next) => onChange(tableToEdges(next, questions));
  const pick = (index, value) => {
    if (value === NEW_PASS || value === NEW_FAIL) { onNewVerdict(index, value === NEW_PASS); return; }
    if (value === NEW_STEP) { onNewStep(index); return; }
    if (index === table.routes.length) commit({ ...table, otherwise: { ...table.otherwise, to: value } });
    else commit({ ...table, routes: table.routes.map((r, j) => (j === index ? { ...r, to: value } : r)) });
  };

  return (
    <RouteTable
      questions={questions}
      value={table}
      onChange={commit}
      readOnly={readOnly}
      otherwiseRequired
      renderTarget={(route, i) => {
        const index = route === 'otherwise' ? table.routes.length : i;
        const value = route === 'otherwise' ? table.otherwise.to : route.to;
        return (
          <TargetPicker
            graph={graph}
            nodeId={nodeId}
            value={value || ''}
            disabled={readOnly}
            className="min-w-[160px] flex-1"
            ariaLabel={route === 'otherwise' ? 'Otherwise goes to' : `${route.name || `Route ${index + 1}`} goes to`}
            onChange={(v) => pick(index, v)}
          />
        );
      }}
    />
  );
}
